<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <ToggleMenuBar
              v-model="state.menu"
              :first-menu="TICKET_MENU.SINGLE"
              :second-menu="TICKET_MENU.COUPLE"
              v-if="isMenuBar"
            />
            <p class="modal-notice" v-if="!isEmpty(subText)">{{ subText }}</p>
            <EmptyItems v-if="isEmpty(state.list)" />
            <div class="scroll-inner" v-if="!isEmpty(state.list)">
              <ul class="ticket-list pd0">
                <MemorialTicket
                  :title="item.name"
                  :price="item.price"
                  :value="item.productNo"
                  v-for="item in state.list"
                  v-model="state.productNo"
                  is-not-state
                  v-if="!isState"
                />

                <!--                <MemorialTicket-->
                <!--                  :title="item.name"-->
                <!--                  :price="item.price"-->
                <!--                  :value="item.itemNo"-->
                <!--                  v-for="item in state.list"-->
                <!--                  v-model="state.itemNo"-->
                <!--                  :state="stateBinding(item.itemType)"-->
                <!--                  v-if="isState"-->
                <!--                  :payment-date="item.paymentDate"-->
                <!--                />-->
              </ul>
            </div>
          </div>
          <BasicButton
            modal-btn
            left-inner-class="medium"
            left-text="닫기"
            @leftEvent="close"
            @rightEvent="fnFetch"
            right-inner-class="primary medium"
            :right-text="rightText || '선택'"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { purchaseCall } from '@/common/utils/module/NativeRequest';
import { TICKET_MENU } from '@/common/constants/ConstCode';
import ToggleMenuBar from '@/components/common/layouts/ToggleMenuBar.vue';
import { computed, onBeforeMount, reactive, watch } from 'vue';
import MemorialTicket from '@/components/common/memorial/MemorialTicket.vue';
import BasicButton from '@/components/common/layouts/BasicButton.vue';
import store from '@/store';
import EmptyItems from '@/components/common/layouts/EmptyItems.vue';
import { fnShowIsAppPurchaseModal, isApp, isEmpty, pointPurchase, REMOVE_EMPTY_PARAMS } from '@/common/utils/Util';
import { modalList, show, showDoneModal, showTextModal } from '@/common/utils/ModalState';
import { nativeInAppPurchase } from '@/common/utils/module/NativeRequest';
import { toastAlert } from '@/common/utils/module/ToastSupport';
const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, isMenuBar, list, rightText, isState, isCouple, isPurchase, subText } = props.data;
const user = computed(() => store.getters['user/getUserData']);
onBeforeMount(async () => {
  state.list = list;
});

const state = reactive({
  productNo: '',
  itemNo: '',
  menu: TICKET_MENU.SINGLE,
  list: []
});

watch(
  () => state.menu, // 감시할 여러 반응형 데이터를 배열로 묶기
  newMenu => {
    const list = store.getters['item/getShopItemList'];
    if (newMenu === TICKET_MENU.SINGLE) {
      state.list = list?.filter(item => item?.productCode?.includes('SINGLE'));
    }
    if (newMenu === TICKET_MENU.COUPLE) {
      state.list = list?.filter(item => item?.productCode?.includes('COUPLE'));
    }
  }
);

// const stateBinding = itemType => {
//   if (itemType.includes('COUPLE')) {
//     if (isCouple) return true;
//     if (!isCouple) return false;
//   }
//   return !isCouple;
// };

const fnFetch = async () => {
  // 이용권을 선택 안했을 경우
  if (!state.productNo && !state.itemNo) {
    toastAlert('추모관 이용권을 선택해 주세요.', 2000);
    return false;
  }

  // 더보기 - 추모관 이용권 사용 파트에서 사용됨
  if (isState) {
    const selectItem = state.list.filter(item => item.itemNo === state.itemNo);
    if (selectItem[0]?.count <= 0) {
      showTextModal('이용권의 잔여 갯수가 없습니다.', '확인');
      return false;
    }
  }

  if (isPurchase) {
    const point = await store.dispatch('premium/getPoint');

    const result = state.list.find(item => item.productNo === state.productNo);
    const purchase = {
      productNo: state.productNo,
      category: result?.category,
      productCode: result?.productCode,
      price: result?.price,
      productId: result?.productId,
      name: result?.name
    };
    store.commit('user/setPurchase', purchase);

    if (user.value.isPremium) {
      show(modalList.CONFIRM, {
        contents: `이용을 위해 ${purchase.price}포인트가 사용됩니다.\n 구매하시겠습니까?`,
        doneText: '확인',
        cancelText: '취소',
        doneCallback: async () => {
          if (point >= purchase.price) {
            await pointPurchase();
          } else {
            setTimeout(() => {
              showDoneModal('포인트가 부족합니다 \n 앱내 결제를 이용하여 구매하시겠습니까?', '확인', '취소', () => {
                inAppPurchase(purchase);
              });
            }, 100);
          }
        }
      });
    } else {
      inAppPurchase(purchase);
    }
  }

  // 데이터 혼란을 방지하기위해 공백으로 나오는 데이터를 지워버림
  if (fnCallBack) fnCallBack(REMOVE_EMPTY_PARAMS(state));

  setTimeout(() => {
    emits('close');
  }, 200);
};

const inAppPurchase = purchase => {
  if (isApp()) {
    purchaseCall(purchase.productId);
  } else {
    setTimeout(() => {
      fnShowIsAppPurchaseModal();
    }, 100);
  }
};
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
